import { useAuth } from "context/AuthProvider";
import React, { useState } from "react";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input, Label } from "reactstrap";
import { apiexportacionService } from "services/apiExportacionService";
import { showAppAlert } from "components/common/AppAlerts";

const ExportadorTrazabilidadFichajes = () => {
  const { empresa } = useAuth();
  const [desde, setDesde] = useState(new Date().toISOString().split("T")[0]);
  const [hasta, setHasta] = useState(new Date().toISOString().split("T")[0]);
  const [estado, setEstado] = useState("TODOS");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (hasta < desde) {
      showAppAlert("La fecha hasta no puede ser anterior a la fecha desde.", "warning");
      return;
    }

    try {
      setLoading(true);
      await apiexportacionService.getInformeTrazabilidadFichajes(
        empresa.id,
        desde,
        hasta,
        null,
        estado
      );
    } catch (error) {
      showAppAlert(error?.message || "No se pudo descargar el informe de trazabilidad.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow">
      <Form onSubmit={handleSubmit}>
        <CardHeader>Informe de trazabilidad de fichajes</CardHeader>
        <CardBody>
          <FormGroup row>
            <Col>
              <Label for="trazabilidad-desde">Fecha desde:</Label>
              <Input
                id="trazabilidad-desde"
                type="date"
                value={desde}
                onChange={(e) => setDesde(e.target.value)}
              />
            </Col>
            <Col>
              <Label for="trazabilidad-hasta">Fecha hasta:</Label>
              <Input
                id="trazabilidad-hasta"
                type="date"
                value={hasta}
                onChange={(e) => setHasta(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Label for="trazabilidad-estado">Estado:</Label>
            <Input
              id="trazabilidad-estado"
              type="select"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
            >
              <option value="TODOS">Todos</option>
              <option value="ACTIVOS">Activos</option>
              <option value="ELIMINADOS">Eliminados</option>
            </Input>
          </FormGroup>
        </CardBody>
        <CardFooter className="text-center">
          <Button color="success" type="submit" disabled={loading}>
            {loading ? "Generando..." : "Descargar"}
          </Button>
        </CardFooter>
      </Form>
    </Card>
  );
};

export default ExportadorTrazabilidadFichajes;
